import { format_date, resolveImageUrl } from "../../Utils/helpers";
import { image_url } from "../../Utils/connection_strings";
import "./RideDetailModals.css";

const DetailField = ({ label, value, full }) => (
  <div className={`ride-detail-modal__field ${full ? "ride-detail-modal__field--full" : "ride-detail-modal__field--half"}`}>
    <span className="ride-detail-modal__label">{label}</span>
    <p className="ride-detail-modal__value">{value || "N/A"}</p>
  </div>
);

export default function VehicleDetail({ data, bookingDetails }) {
  const vehicle = data?.vehicle;
  const vehicleType = vehicle?.type || bookingDetails?.vehicleType;

  const vehicleImageSrc =
    resolveImageUrl(vehicle?.vehicleImage, "") ||
    resolveImageUrl(vehicleType?.image, "") ||
    (vehicleType?.image?.imageUrl ? vehicleType.image.imageUrl : "") ||
    (vehicleType?.image && typeof vehicleType.image === "string"
      ? `${image_url}${vehicleType.image}`
      : "");

  return (
    <div
      className="modal fade ride-detail-modal"
      id="vehicleDetails"
      data-bs-backdrop="static"
      tabIndex="-1"
      aria-labelledby="vehicleDetailsTitle"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="ride-detail-modal__inner">
            <div className="ride-detail-modal__header">
              <div>
                <h3 className="ride-detail-modal__title" id="vehicleDetailsTitle">
                  Vehicle Details
                </h3>
                <p className="ride-detail-modal__subtitle">Vehicle assigned to this ride</p>
              </div>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            {vehicleImageSrc && (
              <div className="ride-detail-modal__hero">
                <img
                  src={vehicleImageSrc}
                  alt={vehicle?.name || vehicleType?.name || "Vehicle"}
                  className="ride-detail-modal__avatar ride-detail-modal__avatar--vehicle"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              </div>
            )}

            <div className="ride-detail-modal__grid">
              <DetailField label="Vehicle Name" value={vehicle?.name} full />
              <DetailField label="Vehicle Type" value={vehicleType?.name} full />
              <DetailField
                label="Date Registered"
                value={data?.createdAt ? format_date(data.createdAt, "DD/MM/YYYY") : "N/A"}
              />
              <DetailField label="Plate Number" value={vehicle?.numberPlate} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
